import {
  HttpMethod_POST_getInstance3c6ouf174z7cx as HttpMethod_POST_getInstance,
  HttpMethod_GET_getInstance2m1rvu4d8a2j3 as HttpMethod_GET_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  serializer1x79l67jvwntn as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1cdzkc3mnhoc4 as serializer_0,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_instance1ih0rts2yeaav as Companion_instance,
  Companion_getInstance24vxhhaq3p126 as Companion_getInstance,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2bk062dpuj8t4 as Companion_getInstance_0 } from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/subject/subjectModels.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_1 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_2,
  toDuration7gy6v749ektt as toDuration,
  Duration__compareTo_impl_pchp0f3d3hhywzdbk51 as Duration__compareTo_impl_pchp0f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmailProofClientEndpointsLiveClass;
function EmailProofClientEndpointsLive() {
  if (EmailProofClientEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.eei_1 = fetcher;
        this.fei_1 = subpath;
      }
      gei(input, $completion) {
        return this.eei_1.hei(this.fei_1 + '/start', HttpMethod_POST_getInstance(), serializer(StringCompanionObject_instance), input, serializer(StringCompanionObject_instance), $completion);
      }
      iei(input, $completion) {
        return this.eei_1.hei(this.fei_1 + '/prove', HttpMethod_POST_getInstance(), Companion_instance.k2a(), input, Companion_getInstance().k2a(), $completion);
      }
    }
    initMetadataForClass($, 'EmailProofClientEndpointsLive', VOID, VOID, VOID, [1]);
    EmailProofClientEndpointsLiveClass = $;
  }
  return EmailProofClientEndpointsLiveClass;
}
var AuthenticatedOneTimePasswordProofClientEndpointsLiveClass;
function AuthenticatedOneTimePasswordProofClientEndpointsLive() {
  if (AuthenticatedOneTimePasswordProofClientEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.jei_1 = fetcher;
        this.kei_1 = subpath;
      }
    }
    initMetadataForClass($, 'AuthenticatedOneTimePasswordProofClientEndpointsLive', VOID, VOID, VOID, [1]);
    AuthenticatedOneTimePasswordProofClientEndpointsLiveClass = $;
  }
  return AuthenticatedOneTimePasswordProofClientEndpointsLiveClass;
}
var OneTimePasswordProofClientEndpointsLiveClass;
function OneTimePasswordProofClientEndpointsLive() {
  if (OneTimePasswordProofClientEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.lei_1 = fetcher;
        this.mei_1 = subpath;
      }
    }
    initMetadataForClass($, 'OneTimePasswordProofClientEndpointsLive', VOID, VOID, VOID, [1]);
    OneTimePasswordProofClientEndpointsLiveClass = $;
  }
  return OneTimePasswordProofClientEndpointsLiveClass;
}
var SmsProofClientEndpointsLiveClass;
function SmsProofClientEndpointsLive() {
  if (SmsProofClientEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.nei_1 = fetcher;
        this.oei_1 = subpath;
      }
      pei(input, $completion) {
        return this.nei_1.hei(this.oei_1 + '/start', HttpMethod_POST_getInstance(), serializer(StringCompanionObject_instance), input, serializer(StringCompanionObject_instance), $completion);
      }
      qei(input, $completion) {
        return this.nei_1.hei(this.oei_1 + '/prove', HttpMethod_POST_getInstance(), Companion_instance.k2a(), input, Companion_getInstance().k2a(), $completion);
      }
    }
    initMetadataForClass($, 'SmsProofClientEndpointsLive', VOID, VOID, VOID, [1]);
    SmsProofClientEndpointsLiveClass = $;
  }
  return SmsProofClientEndpointsLiveClass;
}
var UserAuthClientEndpointsLiveClass;
function UserAuthClientEndpointsLive() {
  if (UserAuthClientEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath, idSerializer) {
        this.rei_1 = fetcher;
        this.sei_1 = subpath;
        this.tei_1 = idSerializer;
      }
      uei(input, $completion) {
        return this.rei_1.hei(this.sei_1 + '/login', HttpMethod_POST_getInstance(), ListSerializer(Companion_getInstance().k2a()), input, Companion_getInstance_0().c3k(this.tei_1), $completion);
      }
      vei(input, $completion) {
        return this.rei_1.hei(this.sei_1 + '/token/simple', HttpMethod_POST_getInstance(), serializer(StringCompanionObject_instance), input, serializer(StringCompanionObject_instance), $completion);
      }
    }
    initMetadataForClass($, 'UserAuthClientEndpointsLive', VOID, VOID, VOID, [1]);
    UserAuthClientEndpointsLiveClass = $;
  }
  return UserAuthClientEndpointsLiveClass;
}
var AuthenticatedUserAuthClientEndpointsLiveClass;
function AuthenticatedUserAuthClientEndpointsLive() {
  if (AuthenticatedUserAuthClientEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath, userSerializer, idSerializer) {
        this.wei_1 = fetcher;
        this.xei_1 = subpath;
        this.yei_1 = userSerializer;
        this.zei_1 = idSerializer;
      }
      aej($completion) {
        return this.wei_1.hei(this.xei_1 + '/self', HttpMethod_GET_getInstance(), serializer_0(Unit_instance), Unit_instance, this.yei_1, $completion);
      }
      bej($completion) {
        return this.wei_1.hei(this.xei_1 + '/terminate', HttpMethod_POST_getInstance(), serializer_0(Unit_instance), Unit_instance, serializer_0(Unit_instance), $completion);
      }
    }
    initMetadataForClass($, 'AuthenticatedUserAuthClientEndpointsLive', VOID, VOID, VOID, [0, 1]);
    AuthenticatedUserAuthClientEndpointsLiveClass = $;
  }
  return AuthenticatedUserAuthClientEndpointsLiveClass;
}
function accessToken(_this__u8e3s4, sessionToken, forceInvalidate) {
  var lastRefresh = {_v: Companion_getInstance_1().c1m_1};
  var token = {_v: null};
  if (forceInvalidate == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    forceInvalidate.vah(() => {
      lastRefresh._v = Companion_getInstance_1().c1m_1;
      token._v = null;
      return Unit_instance;
    });
  }
  return accessToken$slambda_0(token, lastRefresh, _this__u8e3s4, sessionToken);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var toUse = $this.cej_1._v;
  var tmp;
  var tmp_0 = System_instance.b1m().v26($this.dej_1._v);
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance_2();
  var tmp$ret$0 = toDuration(4, DurationUnit_MINUTES_getInstance());
  if (Duration__compareTo_impl_pchp0f(tmp_0, tmp$ret$0) > 0) {
    tmp = true;
  } else {
    tmp = toUse == null;
  }
  if (tmp) {
    $this.dej_1._v = System_instance.b1m();
    var tmp_1 = get_AppScope();
    var out = async(tmp_1, VOID, VOID, accessToken$slambda$slambda_0($this.eej_1, $this.fej_1));
    $this.cej_1._v = out;
    toUse = out;
  }
  var tmp_2 = toUse.ga4($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return listOf(to('Authorization', tmp_2));
}
var accessToken$slambda$slambdaClass;
function accessToken$slambda$slambda() {
  if (accessToken$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_accessToken, $sessionToken) {
        this.gej_1 = $this_accessToken;
        this.hej_1 = $sessionToken;
      }
      yah($this$async, $completion) {
        return this.gej_1.vei(this.hej_1, $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    accessToken$slambda$slambdaClass = $;
  }
  return accessToken$slambda$slambdaClass;
}
function accessToken$slambda$slambda_0($this_accessToken, $sessionToken) {
  var i = new (accessToken$slambda$slambda())($this_accessToken, $sessionToken);
  var l = ($this$async, $completion) => i.yah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var accessToken$slambdaClass;
function accessToken$slambda() {
  if (accessToken$slambdaClass === VOID) {
    class $ {
      constructor($token, $lastRefresh, $this_accessToken, $sessionToken) {
        this.cej_1 = $token;
        this.dej_1 = $lastRefresh;
        this.eej_1 = $this_accessToken;
        this.fej_1 = $sessionToken;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    accessToken$slambdaClass = $;
  }
  return accessToken$slambdaClass;
}
function accessToken$slambda_0($token, $lastRefresh, $this_accessToken, $sessionToken) {
  var i = new (accessToken$slambda())($token, $lastRefresh, $this_accessToken, $sessionToken);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  AuthenticatedOneTimePasswordProofClientEndpointsLive as AuthenticatedOneTimePasswordProofClientEndpointsLivexna614349rpo,
  AuthenticatedUserAuthClientEndpointsLive as AuthenticatedUserAuthClientEndpointsLive1zz0879mg87jo,
  EmailProofClientEndpointsLive as EmailProofClientEndpointsLive1alityxkq35k4,
  OneTimePasswordProofClientEndpointsLive as OneTimePasswordProofClientEndpointsLive38lkvnjxnx70k,
  SmsProofClientEndpointsLive as SmsProofClientEndpointsLive2ouvb5xuxwhln,
  UserAuthClientEndpointsLive as UserAuthClientEndpointsLive3v3qnidsvrhq,
  accessToken as accessTokenh4ztdznrxzfp,
};
//endregion

//# sourceMappingURL=authInterfaces.mjs.map
